module.exports = __webpack_public_path__ + "mstile-144x144.png";